import React, { useState } from 'react';
import PropTypes from 'prop-types';
//const { arrayOf, bool, func, shape, string, number } = proptypes;
import { Typography } from '@one-thd/sui-atomic-components';
import { AfterSubmitMessage } from './AfterSubmitMessage';
import { ThumbsUpThumbsDown } from './ThumbsUpThumbsDown';
import { PopoverFeedback } from './PopoverFeedback';
import { useUserFeedback } from '../hooks/useUserFeedback';
import { dataModel } from '../dataModel';

export const ThumbsUpThumbsDownWithPopover = ({
  anchorKey,
  anchorType,
  title,
  thumbsUpOrDownFeedbackLabels,
  skipFeedbackForm,
  reasons,
  feedbackFormLabels,
  customerInsights,
  handleFeedbackData,
  successMessage,
  thanksMessageHideTime,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const {
    feedbackSubmitted,
    handleSelectOption,
    selectedOptionReasons,
    showFeedbackForm,
    handleFeedbackFormClose,
    handleFeedbackFormSubmit,
  } = useUserFeedback({
    anchorKey,
    anchorType,
    skipFeedbackForm,
    reasons,
    customerInsights,
    handleFeedbackData,
  });

  return (
    feedbackSubmitted
      ? <AfterSubmitMessage message={successMessage} thanksMessageHideTime={thanksMessageHideTime} />
      : (
        <>
          <div className="sui-flex sui-items-center sui-gap-1">
            <Typography variant="body-base">{title}</Typography>{' '}
            <ThumbsUpThumbsDown
              onClick={handleSelectOption}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...thumbsUpOrDownFeedbackLabels}
              setAnchorEl={setAnchorEl}
            />
          </div>
          {selectedOptionReasons && (
            <PopoverFeedback
              open={showFeedbackForm}
              anchorEl={anchorEl}
              reasons={selectedOptionReasons}
              onClose={handleFeedbackFormClose}
              onSubmit={handleFeedbackFormSubmit}
              buttonsBaseId={anchorKey}
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...feedbackFormLabels}
            />
          )}
        </>
      )
  );
};

ThumbsUpThumbsDownWithPopover.displayName = 'ThumbsUpThumbsDownWithPopover';
ThumbsUpThumbsDownWithPopover.dataModel = dataModel;

ThumbsUpThumbsDownWithPopover.propTypes = {
  anchorKey: PropTypes.string,
  anchorType: PropTypes.string,
  title: PropTypes.string,
  successMessage: PropTypes.string,
  thanksMessageHideTime: PropTypes.number,
  thumbsUpOrDownFeedbackLabels: PropTypes.shape({
    thumbsUpAriaLabel: PropTypes.string,
    thumbsDownAriaLabel: PropTypes.string,
  }),
  skipFeedbackForm: PropTypes.bool,
  reasons: PropTypes.shape({
    POSITIVE: PropTypes.arrayOf(PropTypes.string),
    NEGATIVE: PropTypes.arrayOf(PropTypes.string),
  }),
  feedbackFormLabels: PropTypes.shape({
    title: PropTypes.string,
    closeButtonAriaLabel: PropTypes.string,
    textAreaPlaceholder: PropTypes.string,
    submitCTA: PropTypes.string,
  }),
  customerInsights: PropTypes.string,
  handleFeedbackData: PropTypes.func.isRequired,
  modelName: PropTypes.string
};

ThumbsUpThumbsDownWithPopover.defaultProps = {
  title: 'Was this helpful?',
  successMessage: AfterSubmitMessage.defaultProps.message,
  thanksMessageHideTime: AfterSubmitMessage.defaultProps.thanksMessageHideTime,
  thumbsUpOrDownFeedbackLabels: {},
  skipFeedbackForm: false,
  reasons: {
    POSITIVE: [],
    NEGATIVE: [
      'Inaccurate',
      'Irrelevant',
      'Unsafe/Offensive',
      'Other',
    ],
  },
  feedbackFormLabels: {},
  anchorKey: null,
  anchorType: null,
  customerInsights: null,
  modelName: null
};
